module.exports = __webpack_public_path__ + "img/bulgogi.88842e15.jpg";